module.exports = __webpack_public_path__ + "img/furniture-icon.2d3fd281.svg";